<template>
   <div>
      <v-container>
         <confirm-dialog ref="confirm" />
         <v-row class="pt-5"></v-row>
         <v-form ref="locationform" v-model="locationform_valid">
            <v-row>
               <v-toolbar dense :color="this.$globalstore.secondary_titleclass" bottom>
                  <v-toolbar-title> Add Location </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn color="indigo" class="white ma-2" outlined @click="saveLocation">
                     Save
                  </v-btn>
                  <v-btn color="indigo" class="white ma-2" outlined @click="goBack()">
                     Back
                  </v-btn>
               </v-toolbar>
            </v-row>
            <v-row>
               <v-col md="6">
                  <v-card flat outlined class="pl-5 pr-10 pb-5">
                     <v-text-field
                        label="Name"
                        v-model="edit_location_name"
                        required
                        :rules="rules_location_name"
                     >
                     </v-text-field>

                     <v-text-field
                        label="Description"
                        v-model="edit_location_description"
                        required
                        :rules="rules_location_description"
                     >
                     </v-text-field>
                  </v-card>
               </v-col>
               <v-col md="6">
                  <v-card flat outlined class="pl-5 pr-10 pb-5">
                     <v-select
                        label="Status"
                        :items="status_select"
                        item-text="text"
                        item-value="id"
                        return-object
                        v-model="edit_location_status"
                        :rules="[(v) => !!v || 'Status is required']"
                        required
                     ></v-select>

                     <v-select
                        label="Off Site"
                        :items="offsite_select"
                        item-text="text"
                        item-value="id"
                        return-object
                        v-model="edit_location_offsite"
                        :rules="[(v) => !!v || 'Off site status is required']"
                        required
                     >
                     </v-select>
                  </v-card>
               </v-col>
            </v-row>
         </v-form>
      </v-container>
   </div>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg";

   export default {
      inject: ["ShowMessage"],

      components: {
         "confirm-dialog": ConfirmDlg,
      },
      data() {
         return {
            edit_location_name: "",
            edit_location_description: "",
            edit_location_status: null,
            edit_location_offsite: null,
            locationform_valid: true,
            status_select: [
               {id: 1, text: "Enabled"},
               {id: 0, text: "Disabled"},
            ],
            offsite_select: [
               {id: 0, text: "No"},
               {id: 1, text: "Yes"},
            ],
            rules_location_name: [(v) => !!v || "Name is required"],
            rules_location_description: [(v) => !!v || "Description is required"],
         };
      },
      methods: {
         goBack() {
            this.$router.push({name: "ManageLocation"});
         },

         saveLocation() {
            if (!this.$refs.locationform.validate()) {
               this.ShowMessage({
                  title: "Error",
                  message: "Please complete the form.",
                  color: "red",
               });
               return;
            } else {
               this.doSaveLocation();
            }
         },

         async doSaveLocation() {
            await this.$http({
               url: "/cca/savelocation.php",
               headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
               },
               data: {
                  name: this.edit_location_name,
                  description: this.edit_location_description,
                  status: this.edit_location_status,
                  offsite: this.edit_location_offsite,
                  userid: this.$globalstore.user.userid,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.error) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Error occurred saving location.",
                     color: "red",
                  });
                  return;
               } else {
                  this.goBack();
               }
            });
         },
      },
   };
</script>
